import * as allConsturctors from './index';

const constructorCache = new Map();

const createFhirResource = (resourceType, resourceJson = {}, group = null) => {
    resourceType = resourceType?.toString() || resourceJson?.resourceType;
    let constructor = undefined;

    if (constructorCache.has(resourceType)) {
        constructor = constructorCache.get(resourceType);
    } else {
        // Try to find constructor directly in allConstructors
        if (allConsturctors[resourceType]) {
            constructor = allConsturctors[resourceType];
        }

        if (constructor) {
            constructorCache.set(resourceType, constructor);
        }
    }

    if (group) {
        resourceJson._group = group;
    }

    return constructor ? new constructor(resourceJson) : resourceJson;
};

export default createFhirResource;
